@if (device) {
  <div style="height: 100%;">  </div>
}
<div class="col-12 col-md-12">
  <div class="interact-control  as-table stf-device-control"
    style="padding: 0; display: flex; flex-direction: column; height: 100%;">
    <div class="as-cell">
      <div class="as-table">
        <!-- deice name container -->
        <div class="column">
          <div class="device-name-container pull-left" uib-dropdown>
            <!-- <span [title]="device.model" class="device-info" [ngClass]="{'bi bi-android':device.platform=='Android','bi bi-apple':device.platform=='iOS'}"></span> -->
            <button (click)="fullViewDevice()"
              [title]="'Click for full view of the device' | translate"
              class="btn btn-sm fullScreenbtn bi bi-fullscreen">
            </button>
            <!-- <a class="stf-vnc-device-name pointer unselectable" uib-dropdown-toggle
            style="color: black; text-decoration: none;">
            <div class="device-small-image">
              <img src="assets/x24/{{'E30HT.jpg' }}">
            </div>
            <span class="device-name-text" style="color: floralwhite; font-size: x-small;">
              {{device.ios ? device.deviceType : device.manufacturer}}
            </span>
            <span class="caret" ng-show="groupDevices.length > 0"></span>
          </a> -->
          <!-- <ul class="dropdown-menu" role="menu" data-toggle="dropdown" *ngIf="groupDevices.length > 0" class="pointer unselectable">
          <li *
            ="let groupDevice of groupDevices">
            <a class="device-name-menu-element" *ngIf="groupDevice.serial != device.serial"
              (click)="controlDevice(groupDevice); $event.stopPropagation()">
              <div class="pull-left">
                <div class="device-small-image">
                  <img src="assets/x24/E30HT.jpg">
                </div>
                <span ng-class="{'current-device': groupDevice.serial === device.serial }">{{
                groupDevices.enhancedName }}</span>
              </div>
              <div class="pull-right" (click)="kickDevice(groupDevice); $event.stopPropagation()" class="kick-device">
                <i class="fa fa-times"></i>
              </div>
              <div class="clearfix"></div>
            </a>
          </li>
        </ul> -->
      </div>
    </div>
    <!-- close button -->
    <div class="column pull-right deviceControl" [class.landscape]="isScreenRotated">
      <button id="stopUsing" type="button" (click)="kickDevice(device,true); $event.stopPropagation()"
        [title]="'Stop Using' | translate" class="btn btn-xs cross-button as-cell pull-right">
        <i class="fa fa-times" style="cursor: pointer;"></i>
      </button>
      <!-- lock and unlock buttons -->
      <button [title]="'Lock' | translate" (click)="press('power')" class="btn btn-primary btn-xs mt-1">
        <i class="fa fa-lock"></i>
      </button>
      @if (!device?.ios) {
        <button [title]="'Unlock' | translate" (click)="press('menu')"
          class="btn btn-primary btn-xs mt-1">
          <i class="fa fa-unlock"></i>
        </button>
      }
      <button class="btn btn-xs btn-primary mt-1" id="scrollUp" type="button" (click)="sendScrollUp()"
        [title]="'Scroll Up' | translate">
        <i _ngcontent-ng-c1967114452="" class="fa fa-arrow-up" style="cursor: pointer;"></i>
      </button>
      <button class="btn btn-xs btn-primary mt-1" id="scrollDown" type="button" (click)="sendScrollDown()"
        [title]="'Scroll Down' | translate">
        <i _ngcontent-ng-c1967114452="" class="fa fa-arrow-down" style="cursor: pointer;"></i>
      </button>
      <button device-control-key="menu" [title]="'Menu' | translate" (click)="key('menu')"
        class="btn btn-primary mt-1 btn-xs no-transition">
        <i class="fa-solid fa-ellipsis-vertical"></i>
      </button>
      <button device-control-key="app_switch" (click)="key('app_switch')" [title]="'App switch' | translate"
        [ngClass]="{'disabled': device?.ios}" class="btn btn-primary mt-1 btn-xs no-transition">
        <i class="fa fa-window-restore"></i>
      </button>
      <button (click)="key('home')" device-control-key="home" [title]="'Home' | translate"
        class="btn btn-xs btn-primary mt-1 no-transition">
        <i class="fa fa-home"></i>
      </button>
      <button device-control-key="back" (click)="back('back')" [title]="'Back' | translate"
        class="btn btn-primary btn-xs mt-1 no-transition">
        <i class="fa fa-mail-reply"></i>
      </button>
      <button
        (click)="toggle('coordinates')"
        [ngClass]="{'toggled': toggleStates['coordinates']}"
        [title]="'Show Co-ordinates' | translate"
        class="btn btn-primary btn-xs mt-1 no-transition">
        <i class="fa fa-crosshairs"></i>
      </button>

      <!-- Throttle Network Button -->
      <button
        [disabled]="device?.ios"
        (click)="toggle('throttle')"
        [ngClass]="{'toggled': toggleStates['throttle']}"
        [title]="'Throttle Network' | translate"
        class="btn btn-primary btn-xs mt-1 no-transition">
        <i class="fa fa-signal"></i>
      </button>

      <!-- Throttle Options Dropdown -->
      @if (showThrottleOptions) {
        <div class="throttle-dropdown-wrapper" [class.landscape]="isScreenRotated">
          <div class="throttle-arrow"></div>
          <div class="throttle-dropdown">
            @for (opt of throttleOptions; track opt) {
              <button (click)="applyThrottle(opt)" class="throttle-option-btn">
                {{ opt.label }}
              </button>
            }
          </div>
        </div>
      }

      <button
        (click)="toggle('geolocation')"
        [ngClass]="{'toggled': toggleStates['geolocation']}"
        class="btn btn-primary btn-xs mt-1 no-transition"
        [title]="'Geolocation' | translate">
        <i class="fas fa-map-marker-alt"></i>
      </button>
    </div>
    @if (geoTestingEnabled) {
      <div class="geolocation-panel" style="position: absolute; left: 100%; top: 60px; margin-left: 10px; width: 418px; background: #fff; border: 1px solid #ddd; border-radius: 4px; padding: 10px; box-shadow: 0 2px 5px rgba(0,0,0,0.15);z-index: 4;">
        <input id="search-box"
          type="text"
          placeholder="Search location or coordinates"
          class="form-control mb-2" />
        <div id="map" style="height: 328px; width: 100%;"></div>
        <div class="mt-2">
          <strong>Selected Coordinates:</strong>
          <span>{{ lat }}, {{ lng }}</span>
        </div>
        <button (click)="sendLocation()" class="btn btn-success btn-sm mt-3">
          Send to Device
        </button>
      </div>
    }
    <div class="column pull-right"></div>
    <!-- two buttons -->
    <div id="showScreen" class="stf-vnc-control-header column pull-right">
      <!-- device orientation buttons -->
      <div class="stf-vnc-right-buttons">
        <!-- <div class="btn-group">
        <button class="btn btn-sm btn-outline-primary" type="button" (click)="tryToRotate('portrait')"
          [ngClass]="currentRotation == 'portrait' ? 'btn-primary' : 'btn-outline-primary'" name="portrait" uib-btn-radio="'portrait'"
          title="Portrait ('Current rotation:' {{ device.display.rotation }}°)">
          <i class="fa fa-mobile"></i>
        </button>
        <button class="btn btn-sm" type="button" (click)="tryToRotate('landscape')"
          name="landscape" [ngClass]="currentRotation == 'landscape' ? 'btn-primary' : 'btn-outline-primary'" uib-btn-radio="'landscape'"
          title="Landscape ('Current rotation:' {{ device.display.rotation }}°)">
          <i class="fa fa-mobile fa-rotate-90"></i>
        </button>
      </div> -->
      <!-- <button type="button" uib-btn-checkbox class="btn btn-xs btn-info" (click)="checkScreen()"
      [(ngModel)]="showScreen">
      <i *ngIf="showScreen" title="Hide Screen" class="fa fa-eye" style="cursor: pointer;"></i>
      <i *ngIf="!showScreen" title="Show Screen" class="fa fa-eye-slash"
      style="cursor: pointer;"></i>
    </button> -->
  </div>
</div>



<!-- mobile section -->


<div class="column">
  @if (device) {
    <div class="as-cell ">
      <div class="ng-file-dro " ng-file-drop="installFile($files)" ng-file-drag-over-class="dragover">
        @if (renderChildComponent) {
          <app-device-context-menu [style.cursor]="cursor"
            [device]="device" [control]="control">
            @if (showScreen) {
              <app-device-screen [control]="control" [device]="device"
                [showScreen]="showScreen" [fullViewDevice]="fullView" [showCoordinates]="showCoordinates"
                (cursorState)="handleChildData($event)" (fullViewState)="fullViewDevice()"
              style="top:1.3vh;padding:2vh;width: 100%;height: 100%;position: relative;display: flex;"></app-device-screen>
            }
            @if (!showScreen) {
              <img class="mobile-wrapper" src='assets/Wrapper/Mobile_wrapper.png'>
            }
          </app-device-context-menu>
        }
      </div>
    </div>
  }
</div>


</div>
</div>
<!-- navbarbuttons -->
<!-- <div class="controls as-cell" style="align-items: flex-end;">
<div class="btn-group btn-group-justified" style="width: inherit;">
  <a device-control-key="menu" title="Menu" class="btn btn-primary btn-lg no-transition">
    <i class="fa fa-bars"></i>
  </a>
  <a (click)="control.keyPress('122')" device-control-key="home" title="Home" class="btn btn-primary btn-lg no-transition">
    <i class="fa fa-home"></i>
  </a>
  <a device-control-key="app_switch" title="App switch"
    class="btn btn-primary btn-lg no-transition">
    <i class="fa fa-square-o"></i>
  </a>
  <a device-control-key="back" title="Back" class="btn btn-primary btn-lg no-transition">
    <i class="fa fa-mail-reply"></i>
  </a>
</div>
</div> -->
</div>
</div>
<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>